import { ProductTileLayout } from "@omni/ui/brand/product/productTile/productTile.config";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { BundleProductModel } from "@/api/mappers/productBundles.mapper";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import {
    BreakpointMatches,
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

const getProductTileLayout = (breakpoints: BreakpointMatches) => {
    if (!isDefined(breakpoints)) return ProductTileLayout.BUNDLE_VERTICAL;

    if (breakpoints.xl) {
        return ProductTileLayout.BUNDLE_VERTICAL;
    } else {
        return ProductTileLayout.BUNDLE_HORIZONTAL;
    }
};

type BundleProductComponentProps = {
    bundleProduct: BundleProductModel;
};

const _BundleProductComponent = ({
    bundleProduct
}: BundleProductComponentProps) => {
    const { breakpoints } = useBreakpoint();

    const productTileLayout = getProductTileLayout(breakpoints);

    return (
        <ProductTile
            className={cn(
                "tw:my-4 tw:h-auto! tw:xl:min-w-50 tw:xl:max-w-50",
                "tw:[&_img]:max-w-[9.8rem] tw:xl:[&_img]:max-w-[unset]",
                "tw:[&_.productTile--rows:first-of-type]:max-w-[9.8rem]! tw:[&_.productTile--cols:first-of-type]:grid-cols-[auto_1fr]!"
            )}
            sku={bundleProduct.product.sku}
            product={bundleProduct.product}
            amount={bundleProduct.quantity}
            allowInstantAddToCart={false}
            productTileConfig={{
                amountOfFeatures: 0,
                tilePadding: true,
                hoverEffect: breakpoints.xl,
                horizontal: !breakpoints.xl,
                border: breakpoints.xl,
                components: productTileLayout()
            }}
        />
    );
};

export const BundleProductComponent = withBreakpoints(_BundleProductComponent);
